import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {EntityFormControl} from "../../../entity/edit/entity-form-builder/entity-form-control";
import {FUIColorPair} from "@fedeltapointofsale/ui";
import {FormGroup} from "@angular/forms";

@Component({
    selector: "wbo-color-pair-column",
    templateUrl: "./color-pair-column.component.html",
    styleUrls: ["./color-pair-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => ColorPairColumnComponent), multi: true}
    ]
})
export class ColorPairColumnComponent extends AbstractColumnComponent implements OnInit {
    @Input() colorPairComponent: string;
    @Input() required: (dataItem: EntityData<any> | any) => boolean;
    @Input() showClearButton: (dataItem: EntityData<any> | any) => boolean;
    @Input() allowAlpha: boolean = true;

    backgroundSelected: boolean;

    constructor(injector: Injector) {
        super(injector);
    }

    override ngOnInit(): void {
        this.field = this.colorPairComponent;
        super.ngOnInit();
    }

    get backgroundColorField(): string {
        return this.colorPairComponent + ".backgroundColor";
    }

    get foregroundColorField(): string {
        return this.colorPairComponent + ".foregroundColor";
    }

    getColorPair(formGroup: FormGroup): FUIColorPair {
        const backgroundColor: string = formGroup.get(this.backgroundColorField).value;
        const foregroundColor: string = formGroup.get(this.foregroundColorField).value;
        return (backgroundColor == undefined && foregroundColor == undefined) ? undefined : {backgroundColor: backgroundColor, foregroundColor: foregroundColor};
    }

    setColorPair(formGroup: FormGroup, colorPair: FUIColorPair) {
        formGroup.get(this.backgroundColorField).setValue(colorPair ? colorPair.backgroundColor : undefined);
        formGroup.get(this.foregroundColorField).setValue(colorPair ? colorPair.foregroundColor : undefined);
    }

    clear(formGroup: FormGroup): void {
        formGroup.get(this.backgroundColorField).setValue(undefined);
        formGroup.get(this.foregroundColorField).setValue(undefined);
    }

    override editingFields(): string[] {
        return [this.foregroundColorField, this.backgroundColorField];
    }

    setupFormGroup(formGroup: FormGroup, dataItem: EntityData<any>): void {
        if (this.required != undefined) {
            const requiredValue: boolean = this.required(dataItem);
            if (requiredValue !== (<EntityFormControl>formGroup.get(this.foregroundColorField)).required) {
                (<EntityFormControl>formGroup.get(this.foregroundColorField)).required = requiredValue;
                (<EntityFormControl>formGroup.get(this.backgroundColorField)).required = requiredValue;
            }
        }
    }

    canShowClearButton(dataItem: EntityData<any>): boolean {
        if (this.showClearButton) {
            return this.showClearButton(dataItem);
        } else {
            return true;
        }
    }

    override getPlaceholder(dataItem: EntityData<any>): string {
        if (this.placeholderGetter) {
            return this.placeholderGetter(dataItem);
        } else {
            return " ";
        }
    }

    backgroundClicked(): void {
        this.backgroundSelected = true;
    }

    foregroundClicked(): void {
        this.backgroundSelected = false;
    }
}
